import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CaspianXXApiClientAndSurveyIdPairService from '../../../Services/CaspianXXApiClientAndSurveyIdPairService';

// Task-style mass-edit wizard for CaspianXx client-survey pairs. No entityName is set
// so the plain title wins as the header. editedItem is a constructed criteria object
// supplied by the admin page (IsActive/ChangeEndDate/EndDate/ItemList/SearchParams),
// not a domain item, so no itemType is declared.
export default class CaspianXXApiClientAndSurveyIdPairMassEditWindowDescription {
  static titleForCreate = 'Mass Edit CaspianXx Client Survey Id Pairs';
  static titleForEdit = 'Mass Edit CaspianXx Client Survey Id Pairs';
  static serviceFunction = CaspianXXApiClientAndSurveyIdPairService.MassEdit;
  static messageOnSuccess = 'Multi edit has been applied successfully.';
  static finishButtonLabel = 'Save CaspianXx Client Survey Id Pairs';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ChangeEndDate',
          label: 'Change End Date',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
        },
        {
          fieldName: 'EndDate',
          label: 'End Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredDateLatterThanToday,
          disabled: (item) => !item.ChangeEndDate,
        },
        {
          fieldName: 'IsActive',
          label: 'IsActive (Empty means no change)',
          className: 'col-12',
          type: InputTypesEnum.EmptyYesNoSelect,
        },
      ],
    },
  ];
}
